const SsoActionTypes = {
	VALIDATE_USER: {
		SUCCESS: 'VALIDATE_USER_SUCCESS',
		FAILURE: 'VALIDATE_USER_FAILURE',
		PENDING: 'VALIDATE_USER_PENDING',
	},
};

export default SsoActionTypes;
